var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"duration":{ enter: 5000, leave: 500 }}},[(_vm.loading)?_c('div',{staticClass:"loading-bar"},[_c('div',{staticClass:"loading-bar__p"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }